import { container } from 'assets/jss/material-kit-react.js';
import imagesStyle from 'assets/jss/material-kit-react/imagesStyles.js';
import { cardTitle, title } from 'assets/jss/material-kit-react.js';

const homeStyle = {
  container: {
    zIndex: '12',
    color: '#FFFFFF',
    ...container,
  },
  title: {
    ...title,
    display: 'inline-block',
    position: 'relative',
    marginTop: '30px',
    minHeight: '32px',
    color: '#FFFFFF',
    textDecoration: 'none',
  },
  subtitle: {
    fontSize: '1.313rem',
    maxWidth: '500px',
    margin: '10px auto 0',
  },
  main: {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: '3',
  },
  mainRaised: {
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow:
      '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
  },
  '@keyframes opa': {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  typography: {
    // fontSize: window.innerWidth > 979 ? '8rem' : '3rem',
    letterSpacing: '0.5rem',
    textAlign: 'center',
    // textStroke: '1px black',
    textFillColor: 'none',
    textShadow:
      '3px 3px 0 cyan,-1px -1px 0 cyan,1px -1px 0 cyan, -1px 1px 0 cyan,1px 1px 0 cyan',
  },
  ...imagesStyle,
  section: {
    padding: '70px 0',
    textAlign: 'center',
  },
  itemGrid: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  cardTitle,
  smallTitle: {
    color: '#6c757d',
  },
};

export default homeStyle;
